import Carousel from '@acctglobal/carousel-universal'
import { useInView } from 'react-intersection-observer'
import { useMediaQuery } from 'react-responsive'
import { useBraindwSendGA } from 'src/components/hooks/useBraindwSendGA'

import Section from '../Section'
import ProductCardBraindw from './ProductCardBraindw'

interface ProductShelfBraindwProps {
  products?: BraindwMappedProducts[]
  title?: string
  eventAction?: string
}

function ProductShelfBraindw({
  title,
  products,
  eventAction,
}: ProductShelfBraindwProps) {
  const { ref } = useInView()
  const { sendEventGA } = useBraindwSendGA()

  const isMobile = useMediaQuery({
    query: '(max-width: 540px)',
  })

  const isTablet = useMediaQuery({
    query: '(max-width: 1279px)',
  })

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1280px)',
  })

  const itemsQuantity = () =>
    Number(
      (isMobile && 2.99) || (isTablet && 4.99) || (isDesktopOrLaptop && 6.99)
    )

  if (products) {
    sendEventGA(products, eventAction, 'eventImpression')
  }

  return (
    <Section
      className={`layout__section product-shelf__${title?.split(' ')[0]}`}
    >
      <div className="product-shelf__title">
        <h2 className="text__title-section layout__content">{title}</h2>
      </div>
      <div data-fs-product-shelf ref={ref}>
        <Carousel
          gapItems={isMobile ? 8 : 15}
          qtyItems={itemsQuantity()}
          arrow={
            isMobile
              ? { isVisible: false }
              : {
                  isVisible: true,
                  iconColor: 'black',
                  style: { padding: 0, margin: 0, width: 24, height: 24 },
                }
          }
          bullet={{
            isVisible: true,
            bulletEnableColor: '#E5002B',
            bulletDisableColor: '#fff',
            style: {
              border: '1px solid #E5002B',
              padding: 0,
              width: isMobile ? 6 : 12,
              height: isMobile ? 6 : 12,
              borderRadius: 50,
              marginTop: 0,
              marginBottom: 0,
            },
          }}
        >
          {products?.map(
            (product: BraindwMappedProducts, idx: number) =>
              product?.offers?.availableQuantity > 0 && (
                <div style={{ height: 335 }} key={idx}>
                  <div
                    className="layout__content product-shelf"
                    key={`${product.id}`}
                  >
                    <ProductCardBraindw
                      key={product.sku}
                      product={product}
                      eventAction={eventAction}
                    />
                  </div>
                </div>
              )
          )}
        </Carousel>
      </div>
    </Section>
  )
}

export default ProductShelfBraindw
